/**
 * Utility functions for communicating with the parent window
 */

// Send a message to the parent window
export function sendMessageToParent(message: any, targetOrigin = "*") {
    if (typeof window !== "undefined" && window.parent) {
      console.log(`Sending message to parent:`, message)
      window.parent.postMessage(message, targetOrigin)
    } else {
      console.warn("Cannot send message: window or parent not available")
    }
}
  
// Request a token from the parent window
export function requestTokenFromParent() {
    sendMessageToParent({ action: "REQUEST_TOKEN" })
}
  
// Request a new token due to authentication failure
export function requestTokenDueToAuthFailure(error?: string) {
    sendMessageToParent({
      action: "REQUEST_TOKEN",
      reason: "auth_failure",
      error: error,
    })
}
  
  // Listen for messages from the parent window
export function listenToParentMessages(callback: (event: MessageEvent) => void) {
    if (typeof window !== "undefined") {
      window.addEventListener("message", callback)
      return () => window.removeEventListener("message", callback)
    }
    return () => {}
}